import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ReactMarkdown from 'react-markdown';
import BackAndNextButtons from '../components/BackAndNextButtons';
import { useData } from '../Form';
import { useStep } from '../Form';
import { useConferenceConfig } from '../components/ConferenceConfigContext';
import { useState } from 'react';

// The church's own release of liability - separate from CampWaiverForm,
// which is the venue's own waiver (e.g. Mission Springs' SmartWaiver) and
// only applies to conferences held at a venue that requires one.
export default function WaiverForm() {

  const { data, updateData } = useData();
  const { incrementStep } = useStep();
  const { config } = useConferenceConfig();

  const [values, setValues] = useState({
    signedWaiver: data.signedWaiver ?? false,
  });

  const [error, setError] = useState({
    signedWaiver: false,
  });

  function checkForErrors() {
    let newError = {
      signedWaiver: !values.signedWaiver,
    }
    setError(newError);
    return Object.keys(newError).some((k) => newError[k]);
  }

  function handleNext() {
    if (checkForErrors()) {
      // If there are errors, don't proceed
      return;
    } else {
      incrementStep(); // Proceed to the next step
      updateData(values); // Save the current form data
    }
  }
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Release of Liability
      </Typography>
      <ReactMarkdown>{config.waiverMarkdown || ''}</ReactMarkdown>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.signedWaiver}
                onChange={() => setValues({ ...values, signedWaiver: !values.signedWaiver })}
              />
            }
            label={
              <Typography style={{ color: error.signedWaiver ? 'red' : 'inherit' }}>
                By checking this box, I agree to the terms of the release of liability form above *
              </Typography>
            }
          />
        </Grid>
      </Grid>
      <BackAndNextButtons handleNext={handleNext}></BackAndNextButtons>

    </React.Fragment>
  );
}
